import { get } from 'lodash';
import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { CatalogPatientReportExternalEntityDtoParsed, CatalogWithExternalEntitiesDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { RecContentItemDto } from '../../apis/rec-gateway/rec-gateway.dtos';
import { PrimaryTaxonomy } from '../../apis/rec-gateway/rec-gateway.models';
import { EvolveProductDto } from '../../apis/sherpath-app-facade-service/sherpath-app-facade-service.dtos';
import {
  getPatientReportText,
  getSubtitle,
  getTitle
} from '../catalog/catalog.utilities';
import { MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH } from '../course-plan/syllabus.constants';
import { getSimulationLearningSystemResource } from '../../utilities/assignment-types-shared.utilities';

export const getPatientReportAssignmentInfo = (
  catalog: CatalogWithExternalEntitiesDto,
  contentItem: RecContentItemDto,
  primaryTaxonomies: PrimaryTaxonomy[],
  evolveProducts: EvolveProductDto[]
): Partial<AssignmentDto> => {
  const contentId = get(contentItem, 'attributes.contentId', null);
  const patientReportItem = getSimulationLearningSystemResource<CatalogPatientReportExternalEntityDtoParsed>(contentItem, catalog);
  const topicText = getPatientReportText(patientReportItem, catalog);

  return {
    assignmentGoals: [{
      id: null,
      goal: null,
      vtwId: contentId,
      text: null,
    }],
    assignmentTopics: [{
      id: null,
      text: topicText,
      vtwId: null,
    }],
    assignmentQuestions: [],
    title: contentItem ? getTitle(contentItem, catalog, primaryTaxonomies, MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH) : '',
    subtitle: contentItem ? getSubtitle(contentItem, catalog, primaryTaxonomies, evolveProducts, MAX_SYLLABUS_ITEM_TITLE_CHAR_LENGTH) : '',
    contentId
  };
};
